<div class="login-signup-box popout" id="guest-login-container">
    <button type="button" class="close circle-css" (click)="closeDialog()" aria-label="Close dialog">
        <span aria-hidden="true">&times;</span>
    </button>

    <div class="modal-header">
        <h2 [ngStyle]="clientConfig.style.color" id="guest-login-modal-title" class="modal-title">Checkout as a Guest User</h2>
    </div>

    <div class="modal-body">
        <form [formGroup]="guestLoginForm">

            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="guestName" class="sr-only">Full Name</label>
                    <input type="text" id="guestName" formControlName="name" class="form-control"
                        placeholder="Name" maxlength="50" autocomplete="name" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.name}"
                        [attr.aria-invalid]="fc.name.invalid && fc.name.touched"
                        [attr.aria-describedby]="fc.name.errors ? 'guestNameError' : null">
                    <div *ngIf="fc.name.errors" id="guestNameError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.name.errors.required">
                            Please enter your name
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="guestEmail" class="sr-only">Email Address</label>
                    <input type="email" id="guestEmail" formControlName="email" class="form-control" (keyup)="trimEmail()"
                        placeholder="Email" maxlength="100" autocomplete="email" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.email}"
                        [attr.aria-invalid]="fc.email.invalid && fc.email.touched"
                        [attr.aria-describedby]="fc.email.errors ? 'guestEmailError' : null">
                    <div *ngIf="fc.email.errors" id="guestEmailError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.email.errors.required">
                            Please enter email address
                        </div>
                        <div *ngIf="fc.email.errors.email">
                            Please enter valid email
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="guestMobile" class="sr-only">Mobile Number</label>
                    <input type="tel" id="guestMobile" numberOnly formControlName="mobile" class="form-control"
                        placeholder="Mobile" maxlength="10" autocomplete="tel" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.mobile}"
                        [attr.aria-invalid]="fc.mobile.invalid && fc.mobile.touched"
                        [attr.aria-describedby]="fc.mobile.errors ? 'guestMobileError' : null">
                    <div *ngIf="fc.mobile.errors" id="guestMobileError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.mobile.errors.required">
                            Please enter your mobile
                        </div>
                        <div
                            *ngIf="fc.mobile.errors.minlength || fc.mobile.errors.maxlength || fc.mobile.errors.pattern">
                            Please enter valid mobile no of 10 digits
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group" *ngIf="dialogData.deliveryType === deliveryType.Delivery">
                <div class="text-box-wrap">
                    <label for="guestAddress" class="sr-only">Delivery Address</label>
                    <input [attr.disabled]="true" type="text" id="guestAddress" formControlName="address" class="form-control"
                        placeholder="Address" maxlength="50" autocomplete="street-address"
                        [ngClass]="{'is-invalid': formErrors.address}"
                        [attr.aria-invalid]="fc.address.invalid && fc.address.touched"
                        [attr.aria-describedby]="fc.address.errors ? 'guestAddressError' : null">
                    <div *ngIf="fc.address.errors" id="guestAddressError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.address.errors.required">
                            Please enter your address
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group" *ngIf="false">
                <div class="text-box-wrap">
                    <input type="text" formControlName="apartmentNo" class="form-control"
                        [ngClass]="{'is-invalid': formErrors.apartmentNo}" placeholder="Apartment (Optional)"
                        maxlength="50">
                </div>
            </div>

            <div class="form-group">
                <button type="button" (click)="guestLogin()" [disabled]="!guestLoginForm.valid" [ngStyle]="clientConfig.style.bg"
                    [ngClass]="(clientConfig?.outlet?.deliveryType === deliveryType.Pickup && clientConfig?.outlet?.scheduleOrder) ? 'p-po-ptc-continue-as-guest' :
                            (clientConfig?.outlet?.deliveryType === deliveryType.Pickup && !clientConfig?.outlet?.scheduleOrder) ? 'p-on-ptc-continue-as-guest' :
                            (clientConfig?.outlet?.deliveryType === deliveryType.Delivery && clientConfig?.outlet?.scheduleOrder) ? 'd-po-ptc-continue-as-guest' :
			                      'd-on-ptc-continue-as-guest'" id="ContinueAsGuest"
                    class="app-btn btn btn-danger btn-block">Submit</button>
            </div>
        </form>
    </div>
</div>